/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Datapoint
 */
export interface Datapoint {
}

/**
 * Check if a given object implements the Datapoint interface.
 */
export function instanceOfDatapoint(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatapointFromJSON(json: any): Datapoint {
    return DatapointFromJSONTyped(json, false);
}

export function DatapointFromJSONTyped(json: any, ignoreDiscriminator: boolean): Datapoint {
    return json;
}

export function DatapointToJSON(value?: Datapoint | null): any {
    return value;
}

